export const CLOUD_ALL_FILES_ALBUM_ID = '-1';
